
// ==========================================
// 10. src/components/sections/CTASection.js
// ==========================================
import React from 'react';
import { ArrowRight } from 'lucide-react';
import Button from '../common/Button';

const CTASection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-bold text-gray-900 mb-4">
          Ready to Stop the Manual Madness?
        </h2>
        <p className="text-xl text-gray-600 mb-8">
          See your routes, rules, and data connected end-to-end in just 15 minutes
        </p>

        <div className="bg-gradient-to-br from-gray-50 to-blue-50 rounded-2xl p-8 border border-blue-100">
          <div className="space-y-6">
            {/* Direct CTA */}
            <div>
              <p className="text-lg font-semibold text-gray-900 mb-4">
                Ready to transform your operations?
              </p>
              <Button
                href="https://calendly.com/sybrtms/intro-call"
                variant="primary"
                className="group"
                target="_blank"
              >
                Book Your Demo
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition" />
              </Button>
            </div>
          </div>
        </div>


      </div>
    </section>
  );
};

export default CTASection;